import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'signup.goals.title',
		defaultMessage: 'What brings you to Calm?',
		description: 'Title for the goals screen',
	},
	cta: {
		id: 'signup.goals.cta',
		defaultMessage: 'Select all that apply',
		description: 'Cta for the goals screen',
	},
	sleepTitle: {
		id: 'signup.goals.sleepTitle',
		defaultMessage: 'Better sleep',
		description: 'Sleep tile title',
	},
	anxietyTitle: {
		id: 'signup.goals.anxietyTitle',
		defaultMessage: 'Reduce anxiety',
		description: 'Anxiety tile title',
	},
	stressTitle: {
		id: 'signup.goals.stressTitle',
		defaultMessage: 'Reduce stress',
		description: 'Stress tile title',
	},
	happinessTitle: {
		id: 'signup.goals.happinessTitle',
		defaultMessage: 'Increase happiness',
		description: 'Happiness tile title',
	},
	performanceTitle: {
		id: 'signup.goals.performanceTitle',
		defaultMessage: 'Improve performance',
		description: 'Performance tile title',
	},
	gratitudeTitle: {
		id: 'signup.goals.gratitudeTitle',
		defaultMessage: 'Develop gratitude',
		description: 'Gratitude tile title',
	},
	selfesteemTitle: {
		id: 'signup.goals.selfesteemTitle',
		defaultMessage: 'Build self-esteem',
		description: 'Self esteem tile title',
	},
});
